import { render, staticRenderFns } from "./NumberQuestion.vue?vue&type=template&id=2099c2ff"
import script from "./NumberQuestion.vue?vue&type=script&lang=js"
export * from "./NumberQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports